import cx from 'classnames'
import Styles from './ActivityEvent.module.scss'
import { NestedActivityEventProps } from './Types'
import { displayTimestamp } from './utils'

const NestedActivityEvent = ({
  avatar,
  content,
  timestamp,
  isSelected,
  message,
  onClick,
}: NestedActivityEventProps) => {
  return (
    <div className={cx(Styles.nestedRoot, { [Styles.selected]: isSelected })} onClick={onClick}>
      <div className={Styles.leftRail}>{avatar}</div>
      <div className={Styles.main}>
        <div className={Styles.contentText}>
          {content} <span className={Styles.timestamp}>{displayTimestamp(timestamp)}</span>
        </div>
        {message && <div className={Styles.message}>{message}</div>}
      </div>
    </div>
  )
}

export { NestedActivityEvent }
